function Partners() {
  return (
    <>
   
    </>
  );
}

export default Partners;
